/**
 * PlansToSign — payment plans whose acknowledgment letter the agency needs to sign (US 4396),
 * plus ones already signed that Bankers is still reviewing.
 */
import { DocumentTextIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { OathButton } from '../../../shared/OathUI';
import { formatCurrencyWithSymbol } from '../../powerreporting/utils/formatters';
import { formatPlanTerms } from '../../../../services/oathPaymentPlanService';
import { formatScheduleDate } from '../utils/scheduleFormat';

const PlansToSign = ({ plans = [], onSign }) => {
  if (plans.length === 0) return null;

  return (
    <div className="p-4 sm:p-5 bg-amber-50 dark:bg-amber-900/10 rounded-2xl border border-amber-200 dark:border-amber-800">
      <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-1">Letters to sign</h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
        Review and sign the acknowledgment letter for each payment plan. Bankers activates the plan once it has reviewed your signature.
      </p>
      <ul className="space-y-3">
        {plans.map((plan) => {
          const terms = formatPlanTerms(plan, formatCurrencyWithSymbol);
          const signed = !!plan.signedDate;
          return (
            <li
              key={plan.id}
              className="flex flex-wrap items-center justify-between gap-3 p-3 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700"
            >
              <div className="flex items-start gap-3">
                <DocumentTextIcon className="h-6 w-6 text-primary flex-shrink-0" />
                <div>
                  <p className="text-sm font-semibold text-gray-900 dark:text-white">
                    {plan.name || (plan.typeName ? `${plan.typeName} payment plan` : `Plan ${plan.id}`)}
                  </p>
                  <p className="text-xs text-gray-600 dark:text-gray-400">
                    {formatCurrencyWithSymbol(plan.startingBalance)} balance{terms ? ` · ${terms}` : ''}
                  </p>
                </div>
              </div>
              {signed ? (
                <span className="inline-flex items-center gap-1 text-xs font-medium text-emerald-700 dark:text-emerald-300">
                  <CheckCircleIcon className="h-4 w-4" />
                  Signed by {plan.signedName} on {formatScheduleDate(plan.signedDate)} — Bankers is reviewing
                </span>
              ) : (
                <OathButton size="sm" onClick={() => onSign(plan)}>Review &amp; sign</OathButton>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PlansToSign;
